import { TableCell, TableRow } from "@mui/material";
import { hierarchyTableLayout } from "../../Constants/constants";
import { hierarchyTableStyles } from "../../Styles/hierarchyTableStyles";
import type {
  HierarchyTableTotalRowProps,
  TotalBilledHoursCellsProps,
} from "../../Types/types";
import { formatPercent } from "./utils";
import { formatValue } from "../../../OperationsDashboard/utils";

const TotalBilledHoursCells = ({ breakdown }: TotalBilledHoursCellsProps) => (
  <>
    <TableCell sx={hierarchyTableStyles.totalBilledHoursMetricCell("offshore")}>
      {formatValue(breakdown.offshore)}
    </TableCell>
    <TableCell sx={hierarchyTableStyles.totalBilledHoursMetricCell("onsite")}>
      {formatValue(breakdown.onsite)}
    </TableCell>
    <TableCell sx={hierarchyTableStyles.totalBilledHoursMetricCell("total")}>
      {formatValue(breakdown.total)}
    </TableCell>
  </>
);

export const HierarchyTableTotalRow = ({ total }: HierarchyTableTotalRowProps) => {
  const { metrics } = total;

  return (
    <TableRow>
      <TableCell sx={hierarchyTableStyles.totalHierarchyCell}>
        {total.label}
      </TableCell>
      <TableCell
        sx={hierarchyTableStyles.totalDataCell({
          noBorderRight: true,
          align: "right",
          width: hierarchyTableLayout.revenueColWidth,
        })}
      >
        {formatValue(metrics.revenue_cm1)}
      </TableCell>
      <TableCell
        sx={hierarchyTableStyles.totalDataCell({
          noBorderRight: true,
          align: "right",
          width: hierarchyTableLayout.revenueColWidth,
        })}
      >
        {formatValue(metrics.revenue_period)}
      </TableCell>
      <TableCell
        sx={hierarchyTableStyles.totalDataCell({
          align: "right",
          width: hierarchyTableLayout.revenueColWidth,
        })}
      >
        {formatPercent(metrics.gm_percent)}
      </TableCell>
      <TotalBilledHoursCells breakdown={metrics.billed_hours_cm1} />
      <TotalBilledHoursCells breakdown={metrics.billed_hours_period} />
    </TableRow>
  );
};
